import React from 'react'
import { IonContent, IonFooter, IonHeader, IonItem, IonItemDivider, IonLabel, IonList, IonMenu, IonTitle, IonToolbar } from '@ionic/react'
import { goToPage, logOut } from '../helpers/app_actions'
import Api from '../services/Api';
import { useSelector } from 'react-redux';
import { RootState } from '../redux/reducers';

export const MenuSettings = () => {
  const api = Api.getInstance();
  const hasPRO = useSelector((state: RootState) => state.logIn.user.WTTeams)

  // const closeMenu = () => {
  //   menuController.getMenus().then(res => console.log(res))
  //   menuController.close('first').then(res => console.log(res));
  // }

  return (
    <IonMenu side="end" menuId="first" contentId="main" className="safe_padding_bottom">
      <IonHeader>
        <IonToolbar>
          <IonTitle class="text_center">{api.tr('settings')}</IonTitle>
        </IonToolbar>
      </IonHeader>
      <IonContent>
        <IonList>
          <IonItem
            onClick={() => {
              goToPage('/walk/settings')
              // closeMenu()
            }}>{api.tr('account_settings')}</IonItem>
          <IonItem
            onClick={() =>{
              goToPage('/walk/blocked')
            }}>{api.tr('handle_blocked')}</IonItem>
          <IonItem
            onClick={() =>{
              goToPage('/walk/feedback')
            }}>{api.tr('send_feedback')}</IonItem>
          <IonItem
            onClick={() =>{
              goToPage('/walk/settings/purchases')
            }}>My purchases</IonItem>
          {hasPRO? null : 
          <IonItemDivider
            class="p-2"
            color="darkblue"
            onClick={() => {
              goToPage('/walk/getteams')
            }}><IonLabel class="ml-2">{api.tr('upgrade_to_pro')}</IonLabel></IonItemDivider>
          }
          <IonItemDivider class="p-2 mt-4" color="light" onClick={() => logOut()}>
            {api.tr('log_out')}
          </IonItemDivider>
        </IonList>
      </IonContent>
    </IonMenu>
  )
}
